theme.footerSection = (function () {
  function footer() {
    let accordion = true;
    const footerWidgetAccordion = function () {
      accordion = false;
      document
        .querySelectorAll(".footer__widget_toggle")
        .forEach(function (item) {
          item.addEventListener("click", function () {
            const footerWidget = this.closest(".footer__widget"),
              footerWidgetInner = footerWidget.querySelector(
                ".footer__widget_inner"
              );

            if (footerWidget.classList.contains("active")) {
              footerWidget.classList.remove("active");
              slideUp(footerWidgetInner);
            } else {
              footerWidget.classList.add("active");
              slideDown(footerWidgetInner);
              getSiblings(footerWidget.parentElement).forEach(function (item) {
                const footerWidget = item.querySelector(".footer__widget"),
                  footerWidgetInner = item.querySelector(
                    ".footer__widget_inner"
                  );
                footerWidget.classList.remove("active");
                slideUp(footerWidgetInner);
              });
            }
          });
        });
    };
    if (accordion) {
      footerWidgetAccordion();
    }
    // window.addEventListener("resize", function () {
    //   document.querySelectorAll(".footer__widget").forEach(function (item) {
    //     if (window.outerWidth >= 768) {
    //       item.classList.remove("active");
    //       item.querySelector(".footer__widget_inner").style.display = "";
    //     }
    //   });
    //   if (accordion) {
    //     footerWidgetAccordion();
    //   }
    // });

    window.addEventListener("resize", function () {
      document.querySelectorAll(".footer__widget").forEach(function (item) {
        if (window.outerWidth >= 768) {
          item.classList.remove("active");

          const inner = item.querySelector(".footer__widget_inner");
          if (inner) {
            inner.style.display = "";
          }
        }
      });

      if (accordion) {
        footerWidgetAccordion();
      }
    });

    // -------------------------------
    // Logo Animation Module
    // -------------------------------
    const logoAnimationHandler = {
      logoContainer: null,
      logoImage: null,
      scrollHandler: null,
      resizeHandler: null,
      animationFrame: null,

      init() {
        this.logoContainer = document.querySelector(".footer__widget_logo");
        this.logoImage = this.logoContainer?.querySelector("img");

        if (!this.logoContainer || !this.logoImage) return;

        this.scrollHandler = this.handleScroll.bind(this);
        this.resizeHandler = this.handleResize.bind(this);

        window.addEventListener("scroll", this.requestScrollUpdate, {
          passive: true,
        });
        window.addEventListener("resize", this.resizeHandler);

        this.handleResize();
      },

      destroy() {
        window.removeEventListener("scroll", this.requestScrollUpdate);
        window.removeEventListener("resize", this.resizeHandler);
        cancelAnimationFrame(this.animationFrame);
      },

      requestScrollUpdate: () => {
        if (!logoAnimationHandler.animationFrame) {
          logoAnimationHandler.animationFrame = requestAnimationFrame(() => {
            logoAnimationHandler.handleScroll();
            logoAnimationHandler.animationFrame = null;
          });
        }
      },

      handleResize() {
        this.handleScroll();
      },

      handleScroll() {
        const rect = this.logoContainer.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const progress = Math.min(
          Math.max((windowHeight - rect.top) / windowHeight, 0),
          1
        );
        const fullyVisible = rect.top >= 0 && rect.bottom <= windowHeight;
        const finalProgress = fullyVisible ? 1 : progress;
        const scale = 0.8 + 0.2 * finalProgress;
        const opacity = 0.5 + 0.5 * finalProgress;
        this.logoImage.style.transform = `scale(${scale})`;
        this.logoImage.style.opacity = opacity;
      },
    };

    logoAnimationHandler.init();
  }
  return footer;
})();
